var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlobSceneHaikei8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900 0H0V600H900V0Z",
    fill: "#E95CF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.3 600C424.7 533.9 436.2 467.9 475 424C513.8 380.1 580 358.3 629.2 329.2C678.4 300 710.7 263.5 753 245.2C795.4 227 847.7 227 900 227V600H413.3Z",
    fill: "#E336A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.6 600C662.4 567 668.1 533.9 687.5 512C706.9 490 740 479.2 764.6 464.6C789.2 450 805.4 431.7 826.5 422.6C847.7 413.5 873.8 413.5 900 413.5V600H656.6Z",
    fill: "#C62368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 0C384.7 57.7 392.4 115.4 371.4 153.8C350.4 192.3 300.7 211.4 270.1 270.1C239.5 328.8 228.1 427 186.3 449.7C144.4 472.4 72.2 419.7 0 367V0H377Z",
    fill: "#E336A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.5 0C192.4 28.9 196.2 57.7 185.7 76.9C175.2 96.1 150.3 105.7 135.1 135.1C119.8 164.4 114.1 213.5 93.1 224.8C72.2 236.2 36.1 209.9 0 183.5V0H188.5Z",
    fill: "#C62368"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobSceneHaikei8);
export default __webpack_public_path__ + "static/media/blob-scene-haikei-8.cc3da3cbca5e72fbd682a968a94ba3b6.svg";
export { ForwardRef as ReactComponent };